import { Paper, makeStyles, Grid, Typography } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: '#d7f2ff',
    border: '1px solid #0095ff',
    padding: theme.spacing(4, 2)
  },
  robot: {
    [theme.breakpoints.down('md')]: {
      height: theme.spacing(14)
    },
    [theme.breakpoints.up('md')]: {
      height: theme.spacing(10)
    }
  },
  title: {
    fontWeight: 'bold'
  }
}))

export const AnaliseDocumentoInfo = () => {
  const classes = useStyles()

  return (
    <Paper className={classes.container} id="analise-documentos-info">
      <Grid container justifyContent="space-between" spacing={2}>
        <Grid item xs={12} md={4}>
          <Grid container direction="row" alignItems="top" spacing={2}>
            <Grid item xs={3} md={4} lg={3}>
              <img src="/robot.svg" alt="" className={classes.robot} />
            </Grid>
            <Grid item xs={9} md={8} lg={9}>
              <Grid container spacing={1} justifyContent="flex-start">
                <Grid item>
                  <Typography className={classes.title}>
                    Solicitação para análise de documentos.
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography>
                    Não será necessário todos os passos da solicitação.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={7}>
          <Grid container spacing={1} justifyContent="flex-start">
            <Grid item xs={12}>
              <Typography className={classes.title}>
                O que é uma análise de documentos?
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                Com base nos dados da ficha, o sistema fez uma pré validação e
                encontrou inconsistências nos documentos do Motorista,
                Proprietário e/ou veículos. Com base nisso, é necessário
                conferir quais dados estão divergentes e avaliar a liberação.
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  )
}
